import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoginFormComponent } from './login-form/login-form.component';
import { ForgotPasswordComponent } from './login-form/forgot-password/forgot-password.component';

/**
 * Shared module imported by both AppModule (for LoginPopupComponent)
 * and LoginModule (for LoginPageComponent).
 */
@NgModule({
  declarations: [
    LoginFormComponent,
    ForgotPasswordComponent,
  ],
  imports: [
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [
    LoginFormComponent,
    ForgotPasswordComponent,
  ]
})
export class LoginSharedModule {}
